import React from 'react';
import Car from '../../image/icons/map/tripsDetailsTwo/CarIcon.svg';
import Train from '../../image/icons/map/tripsDetailsTwo/TrainIcon.svg';
import Tram from '../../image/icons/map/tripsDetailsTwo/TramIcon.svg';
import Bus from '../../image/icons/map/tripsDetailsTwo/BusIcon.svg';
import Walk from '../../image/icons/map/tripsDetailsTwo/WalkingIcon.svg';
import Cycle from '../../image/icons/map/tripsDetailsTwo/CycleIcon.svg';
import ArrowRight from '../../image/icons/map/tripsDetailsTwo/ArrowRight.png';
import HeLeman from '../../image/icons/map/tripsDetailsTwo/HeLemanIcon.svg';
import BlaBlaDaily from '../../image/icons/map/tripsDetailsTwo/BlabladailyIcon.svg';
import Donkey from '../../image/icons/map/tripsDetailsTwo/DonkeyIcon.svg';
import { type TravelProgressProps } from '../../types/TripPlanner';
import { type UnifiedLegDTO } from '../../types/Itinerary';
import { formatDuration } from '../../tools/TimeRelated';

interface SwitchIconProps {
  segment: UnifiedLegDTO;
}

const SwitchIcon: React.FC<SwitchIconProps> = ({ segment }) => {
  switch (segment.mode.toLowerCase()) {
    case 'car':
      return <img src={Car} />;
    case 'train':
      return (
        <div className="flex items-center">
          <img src={Train} className="mr-1 w-2/2" />
          <p className="text-[10px] justify-center flex m-0 items-center bg-[#4CAF50] text-white p-1 rounded-md">
            {/* {segment.fromStopId[segment.fromStopId.length - 1]} */}
            {segment.routeShortName}
          </p>
        </div>
      );
    case 'rail':
      return (
        <div className="flex items-center">
          <img src={Train} className="mr-1 w-2/2" />
          <p className="text-[10px] justify-center flex m-0 items-center bg-[#4CAF50] text-white p-1 rounded-md">
            {/* {segment.fromStopId[segment.fromStopId.length - 1]} */}
            {segment.routeShortName}
          </p>
        </div>
      );
    case 'tram':
      return (
        <div className="flex items-center">
          <img src={Tram} className="mr-1 w-2/2" />
          <p className="text-[10px] justify-center flex m-0 items-center bg-[#4CAF50] text-white p-1 rounded-md">
            {/* {segment.fromStopId[segment.fromStopId.length - 1]} */}
            {segment.routeShortName}
          </p>
        </div>
      );
    case 'subway':
      return (
        <div className="flex items-center">
          <img src={Tram} className="mr-1 w-2/2" />
          <p className="text-[10px] justify-center flex m-0 items-center bg-[#4CAF50] text-white p-1 rounded-md">
            {/* {segment.fromStopId[segment.fromStopId.length - 1]} */}
            {segment.routeShortName}
          </p>
        </div>
      );
    case 'bus':
    case 'coach':
      return (
        <div className="flex items-center">
          <img src={Bus} className="mr-1 w-2/2" />
          <p className="text-[10px] justify-center flex m-0 items-center bg-brown-bus text-white p-1 rounded-md">
            {/* {segment.fromStopId[segment.fromStopId.length - 1]} */}
            {segment.routeShortName}
          </p>
        </div>
      );
    case 'walk':
      return (
        <div className="flex items-center">
          <img src={Walk} className="mr-1 w-2/2" />
          <p className="text-[10px] text-black mt-auto">{formatDuration(segment.duration)}</p>
        </div>
      );
    case 'bicycle':
      return (
        <div className="flex items-center">
          <img src={Cycle} className="mr-1 w-2/2" />
          <p className="text-[10px] text-black mt-auto">{formatDuration(segment.duration)}</p>
        </div>
      );
    case 'rentbike':
      return (
        <div className="flex items-center">
          <img src={Donkey} className="mr-2 w-7 h-7" alt="rentbike" />
          <p className="text-[10px] text-black">{formatDuration(segment.duration)}</p>
        </div>
      );
    case 'blabladaily':
      return (
        <div className="flex items-center">
          <img src={BlaBlaDaily} className="mr-2 w-7 h-7" alt="blabladaily" />
          <p className="text-[10px] text-black">{formatDuration(segment.duration)}</p>
        </div>
      );
    case 'heleman':
      return (
        <div className="flex items-center">
          <img src={HeLeman} className="mr-2 w-7 h-7" alt="heleman" />
          <p className="text-[10px] text-black">{formatDuration(segment.duration)}</p>
        </div>
      );
    default:
      return null;
  }
};

const TravelProgressTypeTwo: React.FC<TravelProgressProps> = ({ legs }) => {
  return (
    <div id="TravelProgressTypeTwo" className="overflow-y-hidden overflow-x-auto">
      <div className="flex items-center">
        {legs.map((segment, index) => {
          return (
            <div key={`${segment.mode}-${index}`} className="flex items-center" style={{ flex: '0 0 auto' }}>
              <SwitchIcon segment={segment} />
              {index < legs.length - 1 && <img src={ArrowRight} className="ml-2 mr-2 w-[7px] h-[14px]" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TravelProgressTypeTwo;
